import styled from "styled-components";

import { PrimaryText } from "@/components/Typography/Styled";

export const StyledMMLValue = styled(PrimaryText)`
    color: ${(props) => props.theme.lightBlue} !important;
`;
